import orgbook from './OrgBook/Component';
import simplebtnreset from './SimpleButtonReset/Component';
import simplebtnsubmit from './SimpleButtonSubmit/Component';
import simplecheckbox from './SimpleCheckbox/Component';
import simplecheckboxes from './SimpleCheckboxes/Component';
import simplecols2 from './SimpleColumns2/Component';
import simplecols3 from './SimpleColumns3/Component';
import simplecols4 from './SimpleColumns4/Component';
import simplecontent from './SimpleContent/Component';
import simpledatetime from './SimpleDateTime/Component';
import simpleday from './SimpleDay/Component';
import simpleemail from './SimpleEmail/Component';
import simplefieldset from './SimpleFieldSet/Component';
import simplefile from './SimpleFile/Component';
import simpleheading from './SimpleHeading/Component';
import simplenumber from './SimpleNumber/Component';
import simplepanel from './SimplePanel/Component';
import simpleparagraph from './SimpleParagraph/Component';
import simplephonenumber from './SimplePhoneNumber/Component';
import simpleradios from './SimpleRadios/Component';
import simpleselect from './SimpleSelect/Component';
import simpletabs from './SimpleTabs/Component';
import simpletextarea from './SimpleTextArea/Component';
import simpletextfield from './SimpleTextField/Component';
import simpletime from './SimpleTime/Component';
import simpletextfieldadvanced from './SimpleTextFieldAdvanced/Component';
import simpleemailadvanced from './SimpleEmailAdvanced/Component';
import simpletextareaadvanced from './SimpleTextAreaAdvanced/Component';
import simplenumberadvanced from './SimpleNumberAdvanced/Component';
import simpleurladvanced from './SimpleUrlAdvanced/Component';
import simplephonenumberadvanced from './SimplePhoneNumberAdvanced/Component';
import simpletagsadvanced from './SimpleTagsAdvanced/Component';
import simpleaddressadvanced from './SimpleAddressAdvanced/Component';
import simplepasswordadvanced from './SimplePasswordAdvanced/Component';
import simpledatetimeadvanced from './SimpleDateTimeAdvanced/Component';
import simplecheckboxadvanced from './SimpleCheckboxAdvanced/Component';
import simpledayadvanced from './SimpleDayAdvanced/Component';
import simpletimeadvanced from './SimpleTimeAdvanced/Component';
import simpleselectboxesadvanced from './SimpleSelectBoxesAdvanced/Component';
import simpleselectadvanced from './SimpleSelectAdvanced/Component';
import simplecurrencyadvanced from './SimpleCurrencyAdvanced/Component';
import simpleradioadvanced from './SimpleRadioAdvanced/Component';
import simplesurveyadvanced from './SimpleSurveyAdvanced/Component';
import simplesignatureadvanced from './SimpleSignatureAdvanced/Component';
import simplebuttonadvanced from './SimpleButtonAdvanced/Component';
import bcaddress from './BCAddress/Component';
import simplebcaddress from './SimpleBCAddress/Component';
export default {
    orgbook: orgbook,
    simplebtnreset: simplebtnreset,
    simplebtnsubmit: simplebtnsubmit,
    simplecheckbox: simplecheckbox,
    simplecheckboxes: simplecheckboxes,
    simplecols2: simplecols2,
    simplecols3: simplecols3,
    simplecols4: simplecols4,
    simplecontent: simplecontent,
    simpledatetime: simpledatetime,
    simpleday: simpleday,
    simpleemail: simpleemail,
    simplefieldset: simplefieldset,
    simplefile: simplefile,
    simpleheading: simpleheading,
    simplenumber: simplenumber,
    simplepanel: simplepanel,
    simpleparagraph: simpleparagraph,
    simplephonenumber: simplephonenumber,
    simpleradios: simpleradios,
    simpleselect: simpleselect,
    simpletabs: simpletabs,
    simpletextarea: simpletextarea,
    simpletextfield: simpletextfield,
    simpletime: simpletime,
    simpletextfieldadvanced: simpletextfieldadvanced,
    simpleemailadvanced: simpleemailadvanced,
    simpletextareaadvanced: simpletextareaadvanced,
    simplenumberadvanced: simplenumberadvanced,
    simpleurladvanced: simpleurladvanced,
    simplephonenumberadvanced: simplephonenumberadvanced,
    simpletagsadvanced: simpletagsadvanced,
    simpleaddressadvanced: simpleaddressadvanced,
    simplepasswordadvanced: simplepasswordadvanced,
    simpledatetimeadvanced: simpledatetimeadvanced,
    simplecheckboxadvanced: simplecheckboxadvanced,
    simpledayadvanced: simpledayadvanced,
    simpletimeadvanced: simpletimeadvanced,
    simpleselectboxesadvanced: simpleselectboxesadvanced,
    simpleselectadvanced: simpleselectadvanced,
    simplecurrencyadvanced: simplecurrencyadvanced,
    simpleradioadvanced: simpleradioadvanced,
    simplesurveyadvanced: simplesurveyadvanced,
    simplesignatureadvanced: simplesignatureadvanced,
    simplebuttonadvanced: simplebuttonadvanced,
    bcaddress: bcaddress,
    simplebcaddress: simplebcaddress
};
